import styled from 'styled-components';

import { TStyledCircledIconProperties } from './icon.types';

export const StyledWrapper = styled.span`
    display: inline-block;
`;

export const StyledCircledIcon = styled.div<TStyledCircledIconProperties>`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ circleSize }) => `${circleSize / 10}rem`};
    height: ${({ circleSize }) => `${circleSize / 10}rem`};
    padding: 0;

    :before {
        position: absolute;
        min-width: ${({ circleSize }) => `${circleSize / 10}rem`};
        min-height: ${({ circleSize }) => `${circleSize / 10}rem`};
        border-radius: 50%;
        box-shadow: inset 0 0 0 0.15rem
            ${({ theme, color }) => theme.color[color]};
        content: '';
    }
`;
